import React, { useContext, useState, useEffect } from "react";
import _ from "lodash";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Translate, Localize, translate } from "react-i18nify";
import { QRCode } from "react-qrcode-logo";

import { kioskstyles } from "./../../../../kioskstyles";

import "react-phone-number-input/style.css";

import { Button, Grid, Typography, IconButton, TextField } from "@mui/material";

import Logo from "./../../Components/Logo";
import KioskStepper from "./../../Components/Stepper/KioskStepper";
import PhoneKeypad from "./../../Components/CustomerPhoneNumber/PhoneKeypad";
import PhoneConfirm from "./../../Components/CustomerPhoneNumber/PhoneConfirm";
import IdleTimerDisplay from "./../../Components/Shared/IdleTimerDisplay";
import SubtitleWrapper from "./../../Components/Shared/PanelElements/SubtitleWrapper";
import FlexRightPopOutPanel from "./../../Components/Shared/PanelElements/FlexRightPopOutPanel";
import FlexLeftPanel from "./../../Components/Shared/PanelElements/FlexLeftPanel";
import FlexRightPanel from "./../../Components/Shared/PanelElements/FlexRightPanel";
import PhoneDisplay from "./../../Components/CustomerPhoneNumber/PhoneDisplay";
import BackspaceButton from "./../../Components/CustomerPhoneNumber/BackspaceButton";

import QuickStartElement from "./QuickStartElement";
import DonationButtonElement from "./DonationButtonElement";

import CharityDonationContent from "./CharityDonationContent";
import CharitySearchContent from "./CharitySearchContent";
import CharitySelectConfirmContent from "./CharitySelectConfirmContent";
import CharitySearchConfirmContent from "./CharitySearchConfirmContent";

import SocketIOContext from "../../../../contexts/Kiosk/SocketProvider/SocketIOContext";

import { useTheme } from "@mui/material/styles";

import { Dlog } from "./../../../../utils/Dlog";

import HttpContext from "../../../../contexts/HTTP/HttpContext";
import KioskContext from "../../../../contexts/Kiosk/KioskContext";

import { useNavigate } from "react-router-dom";

import { setTranslations, setLocale, getLocale } from "react-i18nify";

import { IdleTimerContext, IdleTimerProvider } from "react-idle-timer";

import { socketEventsHandler } from "./Shared/socketEventHelper";

//import HorizontalLayout from "./Components/CustomerPhoneNumber/HorizontalLayout";
//import VerticalLayout from "./Components/CustomerPhoneNumber/VerticalLayout";
import { useKioskHorizontalStyles } from "./../../../../kioskstyles";

import { Capacitor } from "@capacitor/core";
import DeviceIDPlugin from "./../../../../plugin/DeviceID";

import {
  formatNumber,
  extractNumbers
} from "./../../Components/CustomerPhoneNumber/Shared/PhoneFormatHelper";

import PrinterConnectionModal from "./../Shared/PrinterConnectionModal";

let env = require("./../../../../env");

function displayError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.phonenumber.errors.unablefetchaccount");
    case 401:
      return translate("application.phonenumber.errors.invalidphone");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 423:
      return translate("application.errors.webaccessdisabled");
    case 503:
      return translate("application.errors.serverunavailable");
    default:
      return translate("application.errors.unknownerror");
  }
}

export default function HorizontalLayout({
  setKioskkeyFunc,
  nextFunc,
  loading,
  //errorMessage,
  isNotMobile,
  kioskkey,
  workflowmode,
  getKioskConfiguration
}) {
  const theme = useTheme();
  const { simplepost } = useContext(HttpContext);

  //const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const {
    //customerName,
    customerFirstName,
    customerLastName,
    customerID,
    charityName,
    charityID,
    setCustomerNameAndID,
    numBags,
    setNumBags,
    numLabels,
    setLabels,
    sessionID,
    setAll,
    customerReset
  } = useContext(KioskContext);

  const {
    isConnected,
    socketEvents,
    qrCode,
    connect,
    disconnect,
    getSocket,
    sendEvent,
    clearSocketEvents,
    getKioskTheme
  } = useContext(SocketIOContext);

  const [phonenumber, setPhonenumber] = useState("");
  const [showconfirmdialog, setShowconfirmdialog] = useState(false);

  //charities, search, selectconfirm, searchconfirm
  const [drawerMenuMode, setDrawerMenuMode] = useState("charities");
  const [selectedCharity, setSelectedCharitiy] = useState({
    name: "default",
    id: null
  });

  const [showDrawerMenu, setShowDrawerMenu] = useState(false); //Switch to ShowDrawerMenu

  const [interval, setInterval] = useState(null);

  const navigate = useNavigate();

  const kiosktheme = getKioskTheme();
  let showQuickStart = kiosktheme?.quickStart;
  let showDonationButton = kiosktheme?.enableCharities;

  // console.log(
  //   "showDonationButton kiosktheme?.enableCharities",
  //   kiosktheme?.enableCharities
  // );

  // console.log("showDonationButton showDonationButton", showDonationButton);

  // console.log(
  //   "showDonationButton showDonationButton == true",
  //   showDonationButton == true
  // );

  //Type check: for initial veriable is boolean, but refresh is string
  if (showQuickStart == true) {
    showQuickStart = "true";
  }
  if (showDonationButton == true) {
    showDonationButton = "true";
  }

  // console.log("showQuickStart", showQuickStart);
  // console.log("showDonationButton", showDonationButton);

  const QuickStartElementELEMENT = showQuickStart && QuickStartElement;

  // console.log("QuickStartElementELEMENT", QuickStartElementELEMENT);

  //Logic for response from Socket.IO //Just for the horizontal view
  useEffect(() => {
    socketEventsHandler(
      socketEvents,
      sessionID,
      setAll,
      setErrorMessage,
      setShowconfirmdialog,
      clearSocketEvents
    );
    // Dlog(
    //   "I think an event happened! (ACustomerPhoneNumber HorizontalLayout)",
    //   socketEvents
    // );
    // if (socketEvents == null) {
    //   console.log(
    //     "(ACustomerPhoneNumber HorizontalLayout) socketEvents is null, ignoring"
    //   );
    //   return;
    // }

    // let socketdata = socketEvents.data;
    // Dlog("socketdata", socketdata);

    // let action = socketdata.action;

    // switch (action) {
    //   case "REQUESTCUSTOMERINFO_RESULT":
    //     console.log("Got customer Info", socketdata.data);

    //     if (socketdata.result == "SUCCESS") {
    //       var customerFirstName = socketdata.data.firstName;
    //       var customerLastName = socketdata.data.lastName;
    //       var customerID = socketdata.data.uniqueID;

    //       setAll(
    //         //customerName, //customerName
    //         customerFirstName, //customerFirstName
    //         customerLastName, //customerLastName
    //         customerID, //customerID
    //         null, //numBags
    //         null, //numLabels
    //         null, //labelsList
    //         sessionID //sessionID
    //       );

    //       setErrorMessage("");
    //       setShowconfirmdialog(true);
    //     }
    //     break;
    // }
  }, [socketEvents]);

  const keypadDone = async () => {
    console.log("next called");

    let payload = {
      type: "REQUESTCUSTOMERINFO",
      payload: { type: "phone", value: phonenumber }
    };

    sendEvent(payload, () => {
      console.log("onEventSent");
    });

    return;
  };

  const hideConfirmDialog = async () => {
    setPhonenumber("");
    setShowconfirmdialog(false);
  };

  const displaystyleForconfirmdialog = async () => {
    Dlog("displaystyleForconfirmdialog", showconfirmdialog);

    if (showconfirmdialog) {
      return { display: "none" };
    } else {
      return { display: "block" };
    }
  };

  const backspacepress = async () => {
    let newNumber = phonenumber;

    if (newNumber.length > 0) {
      newNumber = newNumber.substring(0, newNumber.length - 1);
    }

    setPhonenumber(newNumber);
  };

  const next = async () => {
    navigate("/numbags");
  };

  const nextWithCharity = async selectedCharity => {
    if (!selectedCharity) {
      return console.error("No Charity Selected!");
    }

    setAll(
      customerFirstName,
      customerLastName,
      customerID, //customerID
      selectedCharity.Title, //charityName
      selectedCharity.id, //charityID
      null, //numBags
      null, //numLabels
      null, //labelsList
      sessionID //sessionID
    );

    navigate("/numbags");
    return;
  };

  const onIdle = async () => {
    if (env.IDLETIMER) {
      const kiosktheme = getKioskTheme();
      if (kiosktheme.bilingual) {
        setLocale("fr");
      }

      navigate("/language");
    }
  };

  const clickCharities = async () => {
    //console.log("[DEBUG] showDrawerMenu", showDrawerMenu);
    const newShowDrawMenu = !showDrawerMenu;
    setShowDrawerMenu(newShowDrawMenu);

    if (newShowDrawMenu == true) {
      setDrawerMenuMode("charities");
    }
  };

  // charityObj: {
  //   Title: Title,
  //   Description: Description,
  //   id: CharityId
  // }
  const selectCharityEntity = charityObj => {
    setSelectedCharitiy(charityObj);
    setDrawerMenuMode("selectconfirm");
  };

  const selectCharitySearch = charityObj => {
    setSelectedCharitiy(charityObj);
    setDrawerMenuMode("searchconfirm");
  };

  const modeSelectCharity = charityObj => {
    setDrawerMenuMode("charities");
  };

  const modeSearchCharity = charityObj => {
    setDrawerMenuMode("search");
  };

  // const isNotMobile = useMediaQuery("(min-width:600px)");
  // const isLandscape = useMediaQuery("(orientation:landscape)");

  // Dlog("locale", getLocale());
  //const kioskTheme = getKioskTheme();
  const kioskstyles = useKioskHorizontalStyles();

  return (
    <IdleTimerProvider timeout={30000} onIdle={onIdle}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        style={kioskstyles.GridFullHeightFix}
      >
        <FlexLeftPanel isNotMobile={isNotMobile}>
          <div
            class="ks_flexLeftPanelContents"
            style={kioskstyles.flexLeftPanelContents}
          >
            <div class="ks_flexParentPanel" style={kioskstyles.flexParentPanel}>
              <div
                class="ks_flexPanelLayoutA_TopContainer"
                style={kioskstyles.flexPanelLayoutA_FillContainer}
              >
                {/* <div
                class="ks_flexPanelLayoutB_TopContainer"
                style={kioskstyles.flexPanelLayoutB_TopContainer}
              > */}
                <Logo />
                {/* </div>
              <div
                class="ks_flexPanelLayoutB_MidContainer_M"
                style={{
                  ...kioskstyles.flexPanelLayoutB_MidContainer,
                  flexDirection: "row",
                  //alignContent: "space-between",
                  flexWrap: "wrap"
                }}
              > */}
                <div
                  class="fontSecondaryText"
                  style={{
                    ...kioskstyles.PleaseSignInElement
                  }}
                >
                  <Translate value="application.theme.quickStartQRTitle" />
                </div>
                {/* QR Widget */}
                {showQuickStart == "true" && <QuickStartElement />}
                {/* DONATION BUTTON */}
                {/* TODO fix inital load and refresh of themeCOntrol Variables for QucikStart + Donation Button */}
                {showDonationButton == "true" && (
                  <DonationButtonElement setShowDrawerMenu={clickCharities} />
                )}
                <KioskStepper
                  activeStep={0}
                  backUrl={"/language"}
                  workflowmode={workflowmode}
                  getKioskConfiguration={getKioskConfiguration}
                  enableBackFunctionOverwrite={showDrawerMenu}
                  backFunction={() => {
                    setShowDrawerMenu(false);
                  }}
                />
              </div>
              {/* <div
                style={{
                  ...kioskstyles.flexPanelLayoutB_BotContainer,
                  //position: "fixed",
                  bottom: "10.5vh"
                }}
              > */}

              {/* </div> */}
            </div>
          </div>
        </FlexLeftPanel>

        <FlexRightPopOutPanel show={showDrawerMenu}>
          {drawerMenuMode == "charities" && (
            <CharityDonationContent
              modeSearchCharity={modeSearchCharity}
              setSelectedCharity={selectCharityEntity}
            />
          )}
          {drawerMenuMode == "search" && (
            <CharitySearchContent setSelectedCharity={selectCharitySearch} />
          )}
          {drawerMenuMode == "selectconfirm" && (
            <CharitySelectConfirmContent
              selectedCharity={selectedCharity}
              cancelFunc={modeSelectCharity}
              confirmCharity={nextWithCharity}
            />
          )}
          {drawerMenuMode == "searchconfirm" && (
            <CharitySearchConfirmContent
              selectedCharity={selectedCharity}
              cancelFunc={modeSelectCharity}
              confirmCharity={nextWithCharity}
            />
          )}
        </FlexRightPopOutPanel>

        <FlexRightPanel isNotMobile={isNotMobile}>
          <div
            id="rightpanelcontents"
            style={kioskstyles.flexRightPanelContents}
          >
            <div
              style={{
                ...kioskstyles.flexParentPanel,
                marginLeft: "10vh, clamp(20px, 3vw, 95px)",
                marginRight: "10vh, clamp(20px, 3vw, 95px)"
              }}
            >
              <div style={kioskstyles.flexPanelLayoutD}>
                <SubtitleWrapper isNotMobile={isNotMobile}>
                  <Translate value="application.theme.telephoneEnterNumberText" />
                </SubtitleWrapper>
                <div style={kioskstyles.phonenumber.enterSlowlyText}>
                  <Translate value="application.theme.telephoneEnterSlowlyText" />
                </div>

                <div
                  id="phonedisplay"
                  style={{
                    display: "flex",
                    //marginTop: "10.5vh",
                    width: "100%",
                    justifyContent: "center"
                  }}
                >
                  <PhoneDisplay value={phonenumber} />
                  <BackspaceButton
                    show={!showconfirmdialog}
                    onClick={backspacepress}
                  />
                </div>

                <div
                  id="PhoneBlock"
                  style={{ width: "100%", height: "52.8vh" }} // Used to keep the model and keypad lined up
                >
                  <PhoneKeypad
                    phonenumber={phonenumber}
                    setPhonenumber={setPhonenumber}
                    keypadDone={keypadDone}
                    loading={loading}
                    errorMessage={errorMessage}
                    showconfirmdialog={showconfirmdialog}
                  />
                  <PhoneConfirm
                    phonenumber={phonenumber}
                    showconfirmdialog={showconfirmdialog}
                    hideConfirmDialog={hideConfirmDialog}
                    next={next}
                  />
                </div>
              </div>
            </div>
          </div>
        </FlexRightPanel>
      </Grid>
      <IdleTimerDisplay />
      <PrinterConnectionModal />
    </IdleTimerProvider>
  );
}
